module.exports = __webpack_public_path__ + "static/media/copy_grey.27d6ff68.png";